import React from 'react'
import makeStyles from '@mui/styles/makeStyles';
import CircularProgress from '@mui/material/CircularProgress'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
    loading: {
        zIndex: 9999,   
        position: 'fixed',
        left: 0,
        right: 0,
        top: 'calc(50% - 20px)',
        margin: 'auto',
        height: '40px',
        width: '40px',
        '& img': {
            position: 'absolute',
            height: '25px',
            width: 'auto',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            margin: 'auto',
        },
    },
    card: {
        borderRadius: '8px',
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        width: '64px',
        height: '64px',
        paddingLeft: '12px',
        paddingTop: '12px',
    },
}))

const Loading = (props) => {
    const classes = useStyles()

    return (
        <div
            className={clsx([
                classes.loading,
                {
                    [classes.card]: props.card,
                },
            ])}
        >
            {/* <img src="/logo-circle.svg" alt="" /> */}
            <CircularProgress />
        </div>
    )
}

export default Loading
